import { render, staticRenderFns } from "./homeProject.vue?vue&type=template&id=29511252&"
import script from "./homeProject.vue?vue&type=script&lang=js&"
export * from "./homeProject.vue?vue&type=script&lang=js&"
import style0 from "./homeProject.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports